/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  root: {
    flexGrow: 1,
  },
  realmDetailsInputContent: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    alignItems: "center",
  },
  ssoLink: {
    flexDirection: "row",
    justifyContent: "stretch",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: theme.spacing(45),
    whiteSpace: "nowrap",
  },
  realmMetaData: {
    marginTop: theme.spacing(1),
    paddingLeft: 0,
  },
  toggleButtonGroup: {
    borderColor: theme.palette.text.secondary,
  },
  refreshButton: {
    top: '12px',
    right: '20px',
  },
  multiSelect: {
    marginTop: theme.spacing(1.5),
  }
}));
